import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import Error404Page from '../Error404Page.js';

const WrongQueryError = ({ clang }) => {
    return (
        <div className="results__query-error">
            <Error404Page />
        </div>
    );
};

WrongQueryError.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(WrongQueryError);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/WrongQueryError.js